import React, { useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./index.css";
import {
  addUserComment,
  getUserEngagement,
} from "../../../redux/actions/certificateVerification";
import { SET_USER_ENGAGEMENT_DATA } from "../../../redux/actions/types";
import { Mixpanel } from "../../../config/Mixpanel";
import Constants from "../../../common/constants";
import { toast } from "react-toastify";
const learnersImages = [
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Ellipse_948.png?updatedAt=1687447399800",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Ellipse_949.png?updatedAt=1687447465816",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Ellipse_950.png?updatedAt=1687447465448",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Ellipse_952.png?updatedAt=1687447465787",
];
const UserComment = ({ commentRef }) => {
  const certificateData = useSelector(
    (store) => store?.certificateVerification?.certificateData,
  );
  const engagements = useSelector(
    (store) => store?.certificateVerification?.engagements,
  );
  const userDetails = useSelector(
    (store) => store?.certificateVerification?.userInfo,
  );
  const variant = useSelector(
    (store) => store?.certificateVerification?.userType,
  );
  const [userInput, setUserInput] = useState("");
  const dispatch = useDispatch();
  const randomImages = useMemo(() => {
    return [...learnersImages].sort(() => 0.5 - Math.random()).slice(0, 3);
  }, []);

  function handleSubmit() {
    if (variant === "owner") {
      Mixpanel.track(
        Constants.Mixpanel
          .CERTIFICATE_VERIFICATION_OWNER_PAGE_COMMENT_BUTTON_CLICKED,
      );
    } else if (variant === "recruiter") {
      Mixpanel.track(
        Constants.Mixpanel
          .CERTIFICATE_VERIFICATION_RECRUITER_PAGE_COMMENT_BUTTON_CLICKED,
      );
    } else {
      Mixpanel.track(
        Constants.Mixpanel
          .CERTIFICATE_VERIFICATION_NORMAL_PAGE_COMMENT_BUTTON_CLICKED,
      );
    }

    dispatch(
      addUserComment(
        userDetails?.email,
        userInput,
        certificateData?.unique_certificate_id,
        (successObj) => {
          setUserInput("");
          toast.success("Comment posted successfully.");
          dispatch(
            getUserEngagement(
              certificateData?.unique_certificate_id,
              userDetails?.id,
              (successObj) => {
                const engagementData = successObj?.data;

                const comments = engagementData?.comments || [];

                // Find last occurrence from original array
                const matchIndexFromEnd = [...comments]
                  .reverse()
                  .findIndex(
                    (item) =>
                      item?.certificate_verification_users_id &&
                      userDetails?.id &&
                      item?.certificate_verification_users_id ===
                        userDetails?.data?.id,
                  );

                // Convert reversed index to original index
                const matchIndex =
                  matchIndexFromEnd !== -1
                    ? comments.length - 1 - matchIndexFromEnd
                    : -1;

                let reorderedComments = [];
                console.log("log2", matchIndexFromEnd, matchIndex);
                if (matchIndexFromEnd !== -1) {
                  let matchedItem = comments[matchIndex];
                  matchedItem = {
                    ...matchedItem,
                    user_name: matchedItem?.["user_name"] + " (You)",
                  };

                  const remaining = [
                    ...comments.slice(0, matchIndex),
                    ...comments.slice(matchIndex + 1),
                  ];

                  reorderedComments = [matchedItem, ...remaining];
                } else {
                  reorderedComments = comments;
                }

                dispatch({
                  type: SET_USER_ENGAGEMENT_DATA,
                  payload: { ...engagementData, comments: reorderedComments },
                });
              },
              (errorObj) => {},
            ),
          );
        },
        (errorObj) => {
          toast.error("Couldn’t post your comment. Please try again.");
        },
      ),
    );
  }

  function getStatement() {
    if (engagements?.like_count && engagements?.comment_count) {
      if (engagements?.like_count + engagements?.comment_count === 0) {
        return `Leave a like or comment to celebrate`;
      }

      return `${
        engagements?.like_count + engagements?.comment_count &&
        "+" + (engagements?.like_count + engagements?.comment_count)
      } others are
        celebrating`;
    } else if (engagements?.like_count) {
      if (engagements?.like_count === 0) {
        return `Leave a like or comment to celebrate`;
      }

      return `${
        engagements?.like_count && "+" + engagements?.like_count
      } others are
        celebrating`;
    } else if (engagements?.comment_count) {
      if (engagements?.comment_count === 0) {
        return `Leave a like or comment to celebrate`;
      }
      return `${
        engagements?.comment_count && "+" + engagements?.comment_count
      } others are
        celebrating`;
    } else {
      return `Leave a like or comment to celebrate`;
    }
  }
  return (
    <div className="flex w-full flex-col items-center justify-start gap-2">
      <div className="flex w-full items-center justify-start text-[12px] font-medium text-white/80 md:text-[14px] ">
        {getStatement() !== "Leave a like or comment to celebrate" && (
          <span className="ml-2 mr-1 flex items-center justify-start">
            {randomImages?.map((img, idx) => (
              <img
                key={idx}
                src={img}
                alt={`learner-${idx}`}
                className="-ml-2 h-5 w-5  rounded-full border-[2px] border-[#283B67] object-cover"
              />
            ))}
          </span>
        )}{" "}
        <span className="line-clamp-1 ">
          {" "}
          {getStatement()} {certificateData?.name?.split(" ")?.[0]}’s
          achievement!🎉
        </span>
      </div>
      <div className="mt-2 flex w-full items-center justify-center gap-2">
        <textarea
          className={`multiline-input flex-1 text-[12px] text-white md:text-[14px] ${
            userInput?.length > 100 ? "h-[100px]" : "h-[40px]"
          } item block rounded-lg border-0`}
          style={{
            backgroundColor: `rgba(66, 133, 244, 0.15)`,
            scrollbarWidth: "none", // Firefox
            msOverflowStyle: "none",
            resize: "none",
          }}
          contentEditable="true"
          type="text"
          placeholder="Congratulate or share your thoughts..."
          value={userInput}
          onChange={(e) => {
            setUserInput(e?.target.value);
          }}
          ref={commentRef}
        />
        <button
          className="h-[40px] rounded-lg bg-[#4285F4] px-2 text-[12px] font-semibold text-white disabled:opacity-50 md:text-[14px]"
          disabled={userInput?.length === 0}
          onClick={handleSubmit}
        >
          Comment
        </button>
      </div>
    </div>
  );
};

export default UserComment;
